import { API_URL } from "../utils/constants";
import axios from "axios";
import { axiosInstance } from "./httpClient";

const userId = () => {
  return localStorage.getItem("id");
};

const userToken = () => {
  return localStorage.getItem("token");
};
// creates a lessons
export const createLesson = async (payload: any) => {
  let token = localStorage.getItem("token");
  try {
    let response = await axiosInstance.post(`${API_URL}/lessons/create`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//get's the language the trainer can teach
export const languageTaught = async () => {
  let id = userId();
  let token = userToken();
  try {
    let response = await axiosInstance.get(`${API_URL}/teachers/languages-taugt/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// fetches all the lessons
export const fetchLessons = async () => {
  let id = userId();
  let token = userToken();

  try {
    let response = await axiosInstance.get(`${API_URL}/teachers/${id}/lessons`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response?.data?.result;
  } catch (error: any) {
    throw error;
  }
};

export const deleteHandler = async (id: string) => {
  let token = userToken();
  try {
    let response = await axiosInstance.delete(`${API_URL}/lessons/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response?.data?.result; // Return the result of the API call
  } catch (error: any) {
    throw error;
  }
};
